import { useEffect, useState } from "react";

const LINKS = [
  { label: "热搜榜单", href: "#hot" },
  { label: "检索目录", href: "#catalog" },
  { label: "精选话题", href: "#featured" },
  { label: "人物档案", href: "#people" },
  { label: "找瓜指南", href: "#guide" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed top-0 inset-x-0 z-50 transition-all duration-300 " +
        (scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent")
      }
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3.5">
        <a
          href="#search"
          className={
            "flex items-center gap-2.5 whitespace-nowrap font-heading text-lg font-bold " +
            (scrolled ? "text-foreground-950" : "text-foreground-50")
          }
        >
          <span
            className={
              "flex h-9 w-9 items-center justify-center rounded-lg " +
              (scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50")
            }
          >
            <i className="ri-focus-2-line text-lg" />
          </span>
          看料站
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={
                "text-sm font-medium transition-colors whitespace-nowrap " +
                (scrolled
                  ? "text-foreground-600 hover:text-primary-600"
                  : "text-foreground-100/90 hover:text-white")
              }
            >
              {l.label}
            </a>
          ))}
          <a
            href="#search"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            定向找瓜
          </a>
        </div>

        <button
          aria-label="menu"
          onClick={() => setOpen((v) => !v)}
          className={
            "flex h-10 w-10 items-center justify-center rounded-md md:hidden " +
            (scrolled ? "text-foreground-950" : "text-foreground-50")
          }
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 md:hidden">
          <div className="flex flex-col px-4 py-2">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap border-b border-background-100 py-3 text-sm text-foreground-700 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#search"
              onClick={() => setOpen(false)}
              className="mt-3 mb-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              定向找瓜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}